export { AgeGate } from './age-gate';
